import ConditionOperators from '../../spec/condition-operators';
import FILTER_TYPES from '../../filter-types';

/* eslint-disable indent */
export function getConditionPayload({filter, condition}) {
    switch (filter.type) {
        case FILTER_TYPES.boolean:
            return {
                op: ConditionOperators.equals,
                value: condition.value,
                path: filter.path,
            };
        case FILTER_TYPES.numeric: {
            const numericPayload = {
                op: condition.op,
                path: filter.path,
            };
            if (condition.op === ConditionOperators.between) {
                numericPayload.min = condition.min;
                numericPayload.max = condition.max;
            } else if (condition.op === ConditionOperators.gte
                || condition.op === ConditionOperators.lte) {
                numericPayload.value = condition.value;
            } else {
                return {};
            }
            return numericPayload;
        }
        case FILTER_TYPES.enum:
        case FILTER_TYPES.text:
        case FILTER_TYPES.select:
        default:
            return {
                op: ConditionOperators.in,
                values: condition.values,
                path: filter.path,
            };
    }
}

export default function getCriteriaFromActiveFilters(activeFilters) {
    if (!activeFilters.length) {
        return null;
    }
    const conditions = activeFilters.map(activeFilter => getConditionPayload(activeFilter));
    return {
        op: ConditionOperators.and,
        conditions,
    };
}
